import React, { useEffect } from "react";
import dayjs from "dayjs";
import { DatePicker, Table, Tag, Tooltip } from "antd";
import { FaRegNewspaper } from "react-icons/fa6";
import "./MagazineIndicator.css";

const MAGAZINE_MEDIA_TYPE_ID = "66ab804cd0da793340aca037";

const isMagazineInventory = (record) =>
  String(record?.mediaTypeId || "") === MAGAZINE_MEDIA_TYPE_ID;

const InventoryListCompleted = ({ billingData, handleSelectionChange }) => {
  useEffect(() => {
    if (billingData?.inventories?.length > 0) {
      // Send all inventories (selected by default)
      handleSelectionChange(billingData.inventories);
    }
  }, [billingData?.inventories]);

  const columns = [
    // {
    //   title: "Select",
    //   dataIndex: "select",
    //   key: "select",
    //   align: "center",
    //   render: (_, record) => <Checkbox disabled={true} />,
    // },
    {
      title: "Vendor",
      dataIndex: "CodeNo",
      key: "CodeNo",
      align: "center",
      fixed: "left",
      render: (_, record) => (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.4rem",
          }}
        >
          <span>{record?.isTrading ? record?.ownedBy : record?.CodeNo}</span>
          {isMagazineInventory(record) && (
            <Tooltip title="Magazine inventory — verify the applicable GST treatment">
              <Tag
                color="gold"
                className="magazine-gst-indicator"
              >
                <FaRegNewspaper />
                <span>Magazine</span>
              </Tag>
            </Tooltip>
          )}
        </div>
      ),
    },
    {
      title: "Location",
      dataIndex: "locationName",
      key: "locationName",
      render: (text) => (
        <>
          {text}
          <div style={{ width: "200px", height: "1px" }}></div>
        </>
      ),
    },
    {
      title: "Booking Period",
      dataIndex: "Booking Period",
      key: "Booking Period",
      align: "center",
      render: (_, record) => {
        const rangeValue =
          record.startDate && record.endDate
            ? [
                dayjs(record.startDate, "YYYY-MM-DD"),
                dayjs(record.endDate, "YYYY-MM-DD"),
              ]
            : [];

        return (
          <DatePicker.RangePicker
            value={rangeValue}
            disabled={true}
            format={"DD-MM-YYYY"}
            style={{ width: "230px" }}
          />
        );
      },
    },
    {
      title: "Billing Period",
      dataIndex: "Billing Period",
      key: "Billing Period",
      align: "center",
      render: (_, record) => {
        const bookingStart = record.startDate
          ? dayjs(record.startDate, "YYYY-MM-DD")
          : null;
        const bookingEnd = record.endDate
          ? dayjs(record.endDate, "YYYY-MM-DD")
          : null;

        const billingStart = record.billingStartDate
          ? dayjs(record.billingStartDate, "YYYY-MM-DD")
          : bookingStart;
        const billingEnd = record.billingEndDate
          ? dayjs(record.billingEndDate, "YYYY-MM-DD")
          : bookingEnd;

        const rangeValue =
          billingStart &&
          billingEnd &&
          billingStart.isValid() &&
          billingEnd.isValid()
            ? [billingStart, billingEnd]
            : null;

        return (
          <DatePicker.RangePicker
            value={rangeValue}
            disabled={true}
            format={"DD-MM-YYYY"}
            style={{ width: "230px" }}
          />
        );
      },
    },
    {
      title: (
        <div style={{ whiteSpace: "pre-line", textAlign: "center" }}>
          Campaign Duration{"\n"}(Days)
        </div>
      ),
      dataIndex: "Campaign Duration (Days)",
      key: "Campaign Duration (Days)",
      align: "center",
      render: (_, record) => {
        if (record.startDate && record.endDate) {
          const duration =
            dayjs(record.endDate).diff(dayjs(record.startDate), "day") + 1;
          return <span>{duration}</span>;
        }
        return <span>-</span>;
      },
    },
  ];

  const dataSource = billingData?.inventories || [];

  const components = {
    header: {
      cell: (props) => (
        <th
          {...props}
          style={{
            ...props.style,
            backgroundColor: "#daeffe",
          }}
        />
      ),
    },
  };

  return (
    <div>
      <Table
        columns={columns}
        dataSource={dataSource}
        components={components}
        rowClassName={() => "completed-row"}
        scroll={{ x: "max-content" }}
        pagination={false}
      />
    </div>
  );
};

export default InventoryListCompleted;
